// test669
(669 && 0);
